export function animateOnScroll() {
    let animatedBlocks = document.querySelectorAll('.animate-block');
    const animationClass = "fade-in-bottom";

    let options = {
        rootMargin: '50px',
        threshold: 0.25
    }

    if ('IntersectionObserver' in window) {
        let observer = new IntersectionObserver(animateOnScroll, options);
        [...animatedBlocks].forEach(block => {
            observer.observe(block);
        })
    } else {
        // Don't animate blocks if intersectionObserver is not supported
        // This will protect performance on older devices
        [...animatedBlocks].forEach(animatedBlock => {
            animatedBlock.classList.remove('animate-block');
        })
    }

    function animateOnScroll(entries) {
        entries.forEach(entry => {
            const targetClasses = entry.target.classList;

            if (entry.isIntersecting && !targetClasses.contains(animationClass)) {
                entry.target.classList.add(animationClass);
            }
        })
    }


}